import { useRef, useEffect } from 'react'
import abcjs from 'abcjs'
import { cn } from '@/lib/utils'

interface AbcNotationProps {
  abc: string
  /** Semitone offset applied to the engraving (and to any synth built from it). */
  transpose?: number
  className?: string
}

export default function AbcNotation({ abc, transpose = 0, className }: AbcNotationProps) {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!containerRef.current) return
    // The app chrome already shows the exercise name; drop the ABC T: header
    // so the engraving doesn't repeat it.
    const source = abc
      .split('\n')
      .filter((line) => !/^T:/.test(line.trim()))
      .join('\n')
    try {
      abcjs.renderAbc(containerRef.current, source, {
        visualTranspose: transpose,
        responsive: 'resize',
        paddingtop: 8,
        paddingbottom: 8,
        paddingleft: 0,
        paddingright: 0,
        add_classes: true,
      })
    } catch {
      // Bad ABC mid-edit in the Studio — leave the last good render in place
    }
  }, [abc, transpose])

  return <div ref={containerRef} className={cn('abc-sheet w-full', className)} />
}
